import styled from "@emotion/styled";
import { Description as FollowUpOnFacebookDescription } from "scmp-sdk/components/follow-us-on-facebook/styles";
import { SignUpSuccessMessage } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-success-message";
import {
  CheckEmailMessage as SignUpSuccessCheckEmailMessage,
  Title as SignUpSuccessTitle,
  StyledFollowUsOnFacebook,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-success-message/styles";

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;

  inline-size: 600px;
  min-block-size: 252px;
  margin: auto;
  padding-block: 40px;
  padding-inline: 0;

  border-radius: 8px;

  background-color: #ffffff;

  outline: none;
`;

export const StyledSignUpSuccessMessage = styled(SignUpSuccessMessage)`
  ${StyledFollowUsOnFacebook} {
    margin-block-start: 0;
  }

  ${SignUpSuccessTitle} {
    font-size: 21px;
    line-height: 27px;
  }

  ${SignUpSuccessCheckEmailMessage} {
    font-size: 16px;
  }

  ${FollowUpOnFacebookDescription} {
    font-size: 14px;
  }
`;
